module.exports = __webpack_public_path__ + "img/design_proweels.d119efb9.jpg";